declare const $: any

export class BaseAmountTable {
  protected amountInputs: any
  protected timerID: ReturnType<typeof setTimeout> | null = null
  protected enableZeroAmountsToggle: boolean

  constructor(amountInputSelector: string, enableZeroAmountsToggle = false) {
    this.amountInputs = $(amountInputSelector)
    this.enableZeroAmountsToggle = enableZeroAmountsToggle
    if (this.enableZeroAmountsToggle) {
      this.initToggleZeroAmountButtons()
    }
    this.initResetButtons()
    this.initAmountInputs()
  }

  protected initToggleZeroAmountButtons() {
    $('.zero-amounts-toggle').each((_index, el) => {
      const $el = $(el)
      const labelShow = $el.data('showLabel')
      const labelHide = $el.data('hideLabel')

      const $container = $el.closest('.card')
      const $table = $container.find('table.table')

      this.toggleZeroAmounts($table, $el.data('showZeroAmounts'))

      $el.on('click', () => {
        const showZeroAmounts = $el.data('showZeroAmounts')
        this.toggleZeroAmounts($table, !showZeroAmounts)
        $el.data('showZeroAmounts', !showZeroAmounts)
        $el.text(showZeroAmounts ? labelShow : labelHide)
      })
    })
  }

  protected toggleZeroAmounts(table: any, showZeroAmounts: boolean) {
    const $rows = table.find('tbody tr')
    $rows.each((_index, row) => {
      const $row = $(row)
      if (showZeroAmounts || parseInt($row.find(this.amountInputs.selector).val(), 10) !== 0) {
        $row.removeClass('d-none')
      } else {
        $row.addClass('d-none')
      }
    })
  }

  protected initResetButtons() {
    this.amountInputs.each((_index, element) => {
      this.updateResetAmountButton(element)
    })

    $('.reset_amount').click((e) => {
      const $el = $(e.currentTarget).closest('.edit-amount-container').find(this.amountInputs.selector)
      $el.val($el.data('defaultAmount')).trigger('change')
    })
  }

  protected initAmountInputs() {
    this.amountInputs.on('change keyup', (e) => {
      let val: string | undefined

      if (e.type === 'keyup') {
        const { keyCode } = e as KeyboardEvent
        if (keyCode === 13) {
          const nextInput = this.amountInputs.eq(this.amountInputs.index(e.currentTarget) + 1)
          if (nextInput.length) {
            nextInput.focus(function () {
              $(this).select()
            })
            nextInput.focus()
            return
          }
        }

        if ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105) || keyCode === 8) {
          val = $(e.currentTarget).val() as string
        }
      } else {
        val = $(e.currentTarget).val() as string
      }

      if (val) {
        const $status = $(e.currentTarget).parent().find('.status')
        const options = {
          url: $(e.currentTarget).data('url'),
          method: 'post',
          data: {
            amount: val,
            _method: 'PUT',
          },
          error: () => {
            const $alert = $('#validation_alert')
            $('.modal-body', $alert).html('Error occurred during updating amount!')
            $alert.modal()
            $status.removeClass('loading')
          },
          success: (resp: any) => {
            if (resp.errors.length > 0) {
              const $alert = $('#validation_alert')
              $('.modal-body', $alert).html(resp.errors.join('<br>'))
              $alert.modal()
              $(e.currentTarget).val(resp.amount)
            }
            $status.removeClass('loading')
            this.updateResetAmountButton(e.currentTarget)
          },
        }

        $status.addClass('loading')

        const ajaxReq = () => $.ajax(options)
        if (this.timerID) {
          clearTimeout(this.timerID)
        }
        this.timerID = setTimeout(ajaxReq, 1000)
      }
    })
  }

  protected updateResetAmountButton(el: HTMLElement) {
    const $el = $(el)
    const amount = parseInt($el.val(), 10)
    const defaultAmount = parseInt($el.data('defaultAmount'), 10)
    const button = $el.closest('.edit-amount-container').find('button.reset_amount')

    if (!Number.isNaN(defaultAmount) && defaultAmount !== amount) {
      button.removeClass('reset-amount-invisible')
    } else {
      button.addClass('reset-amount-invisible')
    }
  }
}
